var map = {
	"./TournamentTent_1.png": 1327,
	"./TournamentTent_2.png": 1328
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1326;


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/tournamenttent ^\.\/TournamentTent_.*\.png$
// module id = 1326
// module chunks = 3